import Store from '@/store'
import Default from './default'
import Locale from '@/locale'
import Auth from '@/utils/Auth'

/**
 * Checks if the specified user can accesses specified route
 * @param {*} route
 * @param {*} user
 */
function isAuthorized (route, user) {
  // Don't allow unlogged user to access logged only pages
  if (route.meta && route.meta.requiresAuth && !user) {
    console.log('User is not logged in, but tried to access', route.name)
    return false
  }

  if (route.meta && route.meta.roles && !route.meta.roles.find(role => Auth.hasRole(role, route.meta.ignoreDelegations))) {
    console.log('User does not have rights to access', route.name)
    return false
  }

  return true
}

/**
 * Intended to be used in router 'beforeEach' hook.
 * Checks if currently logged in user can access target route and redirects him if not
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
export function beforeEach (to, from, next) {
  let user = Store.auth && Store.auth.user

  // Don't allow access user to pages that are only for unlogged users
  if (user && to.meta.unauthorizedOnly) {
    console.log('Logged user is trying to access unlogged only page', to.name)
    return next('/404')
  }

  // Some exceptions
  if (user) {
    // Force user to change password
    if (user.changePasswordAfterLogin && (to.name !== 'PasswordChange' && to.name !== 'Logout')) {
      console.log('Password change is forced')
      return next('/password-change')
    }

    // Force user to set company public key
    if (!user.changePasswordAfterLogin && Auth.requiresKey() && (to.name !== 'CompanySetup' && to.name !== 'Logout')) {
      console.log('Company setup is forced')
      return next('/company-setup')
    }
  }

  if (!isAuthorized(to, user)) {
    /*
      User is logged in, but can't acces specified resource.
      Redirect him to his default route.
    */
    if (user) {
      if (to.name === 'Dashboard' && Default[user.role]) {
        console.log('User is trying to access dashboard, but doesnt have rights to do so. Redirecting to default route', Default[user.role])
        return next(Default[user.role])
      }
      return next('/404')
    } else {
      // User is not logged in, redirect him to login
      if (to.name !== 'Login') {
        Store.login.redirect = to.fullPath
        console.log('Must login')
        return next('/login')
      }
    }
  }

  document.title = `${to.meta.title ? Locale.t(to.meta.title) : to.name} - SIPREC`

  return next()
}



// WEBPACK FOOTER //
// ./src/router/auth.js